<template>
  <v-menu v-model="menu_ativo" :close-on-content-click="false">
    <template v-slot:activator="{}">
      <SysBtn class="ml-4" @click="menu_ativo = !menu_ativo">
        <v-icon size="18">mdi-filter</v-icon>
        <span class="ml-1">Filtros</span>
        <span v-show="QTDE_FILTROS > 0" class="ml-1 font-12 text-gray-800">({{ QTDE_FILTROS }} filtro{{ QTDE_FILTROS > 1 ? 's' : '' }})</span>
      </SysBtn>
    </template>

    <div class="w-500 bg-white">
      <v-card-title class="pl-4 pr-1 py-2">
        <div>
          <p class="ma-0 font-18 text-gray-900">Filtragem de produtos</p>
          <p class="ma-0 font-12 font-weight-regular mt-n3 text-gray-200">
            Combine os filtros para visualização dos produtos
          </p>
        </div>

        <v-spacer />

        <v-btn icon @click="menu_ativo = !menu_ativo">
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <div class="px-3 pb-4">
        <FiltroDepartamento
          v-model="filtro.departamento"
          :itensFull="TODOS_OS_PRODUTOS"
          class="mt-3"
        />

        <FiltroSecao
          v-model="filtro.secao"
          :itensFull="TODOS_OS_PRODUTOS_POR_DEPARTAMENTO"
          class="mt-3"
        />

        <FiltroCategoria
          v-model="filtro.categoria"
          :itensFull="TODOS_OS_PRODUTOS_POR_SECAO"
          class="mt-3"
        />

        <FiltroFornecedor
          v-model="filtro.fornecedor"
          :itensFull="TODOS_OS_PRODUTOS_POR_CATEGORIA"
          class="mt-3"
        />

        <v-checkbox v-model="filtro.exibir_produtos_nao_configurados" class="mt-3" label="Exibir somente produtos não configurados."/>
      </div>
    </div>
  </v-menu>
</template>

<script>
import FiltroDepartamento from './filtroDepartamento.vue';
import FiltroSecao from './FiltroSecao.vue';
import FiltroCategoria from './FiltroCategoria.vue';
import FiltroFornecedor from './filtroFornecedor.vue';

export default {
  components: {
    FiltroDepartamento,
    FiltroSecao,
    FiltroCategoria,
    FiltroFornecedor,
},
  props: {
    produtos: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      menu_ativo: false,
      filtro: {
        departamento: [],
        secao: [],
        categoria: [],
        fornecedor: [],
      },
    }
  },
  computed: {
    QTDE_FILTROS() {
      return (this.filtro.departamento ? this.filtro.departamento.length : 0) + (this.filtro.fornecedor ? this.filtro.fornecedor.length : 0);
    },
    TODOS_OS_PRODUTOS() {
      const produtos =  this.produtos.map(map => {
        return {
          ...map,
          id_departamento: map.id_departamento,
          id_secao: map.id_secao,
          id_categoria: map.id_categoria,
          id_fornecedor: map.idfornecedor,
          descricao_departamento: map.descricao_departamento,
          descricao_secao: map.descricao_secao,
          descricao_categoria: map.descricao_categoria,
          descricao_fornecedor: map.razao_social,
        }
      });

      return this.uniqueObjects(produtos);
    },
    TODOS_OS_PRODUTOS_POR_DEPARTAMENTO() {
      return this.filtro.departamento.length === 0
        ? this.TODOS_OS_PRODUTOS
        : this.TODOS_OS_PRODUTOS.filter(item => this.filtro.departamento.some(departamento => departamento.id_departamento == item.id_departamento));
    },
    TODOS_OS_PRODUTOS_POR_SECAO() {
      return this.filtro.secao.length === 0
        ? this.TODOS_OS_PRODUTOS
        : this.TODOS_OS_PRODUTOS_POR_DEPARTAMENTO.filter(item => this.filtro.secao.some(secao => secao.id_secao == item.id_secao));
    },
    TODOS_OS_PRODUTOS_POR_CATEGORIA() {
      return this.filtro.categoria.length === 0
        ? this.TODOS_OS_PRODUTOS
        : this.TODOS_OS_PRODUTOS_POR_SECAO.filter(item => this.filtro.categoria.some(categoria => categoria.id_categoria == item.id_categoria));
    }
  },
  watch: {
    "filtro.departamento"(valor) {
      this.filtro.secao = [];
      this.filtro.categoria = [];
      this.filtro.fornecedor = [];
      this.$emit("filtro-departamentos", valor);
    },
    "filtro.secao"(valor) {
      this.filtro.categoria = [];
      this.filtro.fornecedor = [];
      this.$emit("filtro-secao", valor);
    },
    "filtro.categoria"(valor) {
      this.filtro.fornecedor = [];
      this.$emit("filtro-categoria", valor);
    },
    "filtro.fornecedor"(valor) {
      this.$emit("filtro-fornecedor", valor);
    },
    "filtro.exibir_produtos_nao_configurados"(valor) {
      this.$emit("filtro_exibir_produtos_nao_configurados", valor);
    },
  },
  methods: {
    uniqueObjects(itens) {
      const uniqueArrayObjetos = itens.reduce((acc, current) => {
        const x = acc.find(item => item.id_departamento === current.id_departamento && item.id_secao === current.id_secao && item.id_categoria === current.id_categoria &&  item.idfornecedor === current.idfornecedor);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

      return uniqueArrayObjetos;
    }
  }
}
</script>

<style>

</style>
